import type { FaireProductEntity } from "../../entity_types/product";

export const p_8xhurwu4ah: FaireProductEntity = {
  token: "p_8xhurwu4ah",
  type: "product",
  name: "Women's Waffle Knit Mock Neck Top & Shorts Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/39c16a413127f2688fc63162dfcecf388b2cc1ba72dd3fb0b860a47b2a8a3fbb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee87f8b7d2739442de8970008a00aa6b67e0230ea73d637dd190e9f7ab8b9bc4.jpeg",
    "https://cdn.faire.com/fastly/da0e2f16824d8811586be509f6b7e86757689c4a0eb9f4bc8b7569c012bf32c8.png",
    "https://cdn.faire.com/fastly/9e5973f73dde51c2667d450c9b8c29548b334cc481d49eb8117fe8a70b750e12.jpeg",
    "https://cdn.faire.com/fastly/a57d27eb5405290d2d87b6860c6faf20e35dd3dffb8b31c1169cdfeb54021dbc.png",
    "https://cdn.faire.com/fastly/6aab7a70e939ab8bfe3e17dfd118bd7490c0dacdb7e694dd05148823a078aaf6.png",
    "https://cdn.faire.com/fastly/90a20997784775c0926bd28a7d9f343752ae9458ba05f2a41553eb3476953263.jpeg",
    "https://cdn.faire.com/fastly/181013bf26ea48891e234fea115aa543870a9eeff88c2cd7a2279b98f533a7a2.jpeg",
    "https://cdn.faire.com/fastly/658bb0856176ce8de23f9bcecbeeefda63757f5e4fd588290a5b0674e4c70f92.jpeg"
  ],
  priceDollars: 70,
  description: "Designed for life's in-between moments, the relaxed mock neck delivers a refined, modern silhouette, while the matching short offers easy movement and all-day versatility. \n\nFabrication:\nThe beauty of AirThermal lies in its effortless balance—lightweight enough for layering, cozy enough to wear on its own, and polished enough to take beyond the house. \n\nFeatures:\n● Signature AirThermal waffle knit texture\n● Modern Relaxed-fit Mock Neck Silhouette\n● 3.5\" Inseam Dolphin Hem Short with Drawstring Waist\n\nMaterials & Care:\n● Easy care, colorfast, and machine washable\n● 44% Rayon, 28% Polyester, 24% Nylon, 4% Spandex\n● Retains its softness and shape wash after wash\n\nBest For:\n● Travel days\n● Resort lounging\n● Transitional weather\n\n",
  tags: [],
  msrpDollars: 159,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:13.951Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
